import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ caption, title, subtitle, center = false }) => (
  <div className={center ? "text-center" : ""}>
    <Reveal>
      <p className="font-mono text-xs uppercase tracking-[0.25em] text-sky-600 font-semibold">
        {caption}
      </p>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight uppercase leading-none mt-4 text-slate-900">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.2}>
        <p className={`text-base sm:text-lg text-slate-500 leading-relaxed mt-5 max-w-2xl ${center ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      </Reveal>
    )}
  </div>
);
